module.exports = __webpack_public_path__ + "static/media/favourite_white.da2452cb.svg";